export default {
  minSmall: '(min-width: 575px)',
  minMedium: '(min-width: 767px)',
  minLarge: '(min-width: 991px)',
  maxSmall: '(max-width: 575px)',
  maxMedium: '(max-width: 767px)',
  maxLarge: '(max-width: 991px)',
}
